(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wetravel-reviews-home"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.wetravel-reviews-home').forEach((section) => {
    const track = section.querySelector('.wetravel-reviews-home__track');
    const prev = section.querySelector('[data-wt-prev]');
    const next = section.querySelector('[data-wt-next]');
    if (!track || !prev || !next) return;

    const step = () => {
      const card = track.querySelector('.wetravel-review-card');
      if (!card) return track.clientWidth;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
